import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import PenetrationTesting from "@/pages/PenetrationTesting";
import Blog from "@/pages/Blog";

import Contact from "@/pages/Contact";
import CyberThreatMap from "@/pages/CyberThreatMap";
import NotFound from "@/pages/NotFound";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/penetration-testing" element={<PenetrationTesting />} />
            <Route path="/threat-map" element={<CyberThreatMap />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* 404 Not Found - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
